<template>
  <div class="about">
    <ProviderHeader />
    <ProviderBody />
    <div class="my-5 pt-5">
      <ContactUsAction />
    </div>
    <ProviderTuto />
  </div>
</template>

<script>
import { useMeta } from "vue-meta";
import ProviderHeader from "@/components/services/ProviderHeader.vue";
import ProviderBody from "@/components/services/ProviderBody.vue";
import ProviderTuto from "@/components/services/ProviderTuto.vue";
import ContactUsAction from "@/components/partials/ContactUsAction.vue";

export default {
  name: "AboutView",
  components: {
    ProviderHeader,
    ProviderBody,
    ProviderTuto,
    ContactUsAction,
  },
  mounted() {
    // Si tu utilises déjà ton observer global pour les animations :
    import("@/assets/globalJs/global.js").then(({ observeElements }) => {
      observeElements(
        ".slide-right",
        ".slide-left",
        ".fall-down",
        ".image-fade-in"
      );
    });
  },
  setup() {
    useMeta({
      title: "Livraison de matériaux BTP pour fournisseurs – Livratos",
      description: [
        {
          content:
            "Livratos aide les fournisseurs BTP à organiser leurs livraisons de matériaux vers les chantiers des artisans grâce à un réseau de livreurs fiables et réactifs.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.livratos.fr/livraisons-fournisseurs-btp",
        },
      ],
    });
  },
};
</script>
